import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import MetaTags from "./index";
import config from "@/lib/config";
import routes from "@/lib/routes";
import { jsx as _jsx } from "react/jsx-runtime";
export function tags(id, title) {
  return {
    title: `${title} の動画配信なら SPOOX(スプークス)`,
    keywords: `${title},SPOOX,スプークス,動画配信,スカパー！`,
    description: `${title}をピックアップ！SPOOX(スプークス)では、スポーツや映画やアニメ、音楽ライブなど、様々な動画を配信中！`,
    og: {
      type: "article",
      url: `${config.host.vod}${routes.palette(id)}`
    }
  };
}
export default function PaletteMetaTags(_ref) {
  let {
    id,
    title
  } = _ref;
  const props = tags(id, title);
  return /*#__PURE__*/_jsx(MetaTags, _objectSpread({}, props));
}